const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTfgMainlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2930 1467",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer-1",
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,59.2832,242.486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-122.166L50.671,-122.166L50.671,-101.389L23.526,-101.389L23.526,-73.553L49.132,-73.553L49.132,-52.775L23.526,-52.775L23.526,0L0,0L0,-122.166Z",
    style: {
      fill: "rgb(5,38,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,152.197,170.115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.576C-1.74,6.941 -4.171,-16.835 -5.315,-28.533L-6.241,-28.533C-6.664,-20.019 -9.56,7.469 -11.18,22.576L0,22.576ZM-13.229,43.295L-16.236,72.371L-40.191,72.371L-22.921,-49.795L12.115,-49.795L29.801,72.371L5.359,72.371L1.993,43.295L-13.229,43.295Z",
    style: {
      fill: "rgb(5,38,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,251.707,160.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,42.419L0,49.033C0,64.446 -2.838,84.122 -30.844,84.122C-51.532,84.122 -60.515,73.103 -60.515,50.648L-60.515,-9.261C-60.515,-30.507 -49.918,-41.703 -30.35,-41.703C-4.547,-41.703 -0.354,-24.716 -0.354,-8.73L-0.354,-1.06L-24.01,-1.06L-24.01,-11.485C-24.01,-18.21 -25.445,-21.616 -30.35,-21.616C-35.188,-21.616 -36.754,-18.405 -36.754,-11.485L-36.754,53.118C-36.754,59.637 -35.663,64.088 -30.359,64.088C-25.281,64.088 -23.773,60.35 -23.773,52.569L-23.773,42.419L0,42.419Z",
    style: {
      fill: "rgb(5,38,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,551.143,10.806)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.841,
    y: 109.514,
    width: 23.461,
    height: 122.166,
    style: {
      fill: "rgb(5,38,58)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,303.868,242.486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-122.166L23.526,-122.166L23.526,-20.559L53.063,-20.559L50.965,0L0,0L0,-122.166Z",
    style: {
      fill: "rgb(5,38,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,755.827,10.806)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.183,
    y: 109.514,
    width: 23.461,
    height: 122.166,
    style: {
      fill: "rgb(5,38,58)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,417.489,221.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-80.612L-17.792,-80.612L-17.792,-101.389L41.369,-101.389L41.369,-80.612L23.461,-80.612L23.461,20.777L0,20.777L0,-80.612Z",
    style: {
      fill: "rgb(5,38,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,961.608,10.806)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.073,
    y: 109.514,
    width: 23.462,
    height: 122.166,
    style: {
      fill: "rgb(5,38,58)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,557.696,174.277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,14.252L-25.187,14.252L-25.187,47.552L4.337,47.552L1.518,68.209L-48.712,68.209L-48.712,-53.957L1.336,-53.957L1.336,-33.18L-25.187,-33.18L-25.187,-6.405L0,-6.405L0,14.252Z",
    style: {
      fill: "rgb(5,38,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,593.337,157.852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,46.982L0,55.441C0,63.477 1.993,67.208 7.354,67.208C12.766,67.208 14.04,61.675 14.04,55.91C14.04,44.381 11.871,41.044 -0.602,30.607C-14.363,18.949 -21.437,12.047 -21.437,-5.948C-21.437,-23.399 -15.659,-39.481 7.481,-39.481C32.054,-39.481 35.682,-22.721 35.682,-8.739L35.682,-1.708L13.494,-1.708L13.494,-9.026C13.494,-16.439 12.275,-20.104 7.629,-20.104C3.295,-20.104 1.895,-16.375 1.895,-9.455C1.895,-2.098 3.23,1.534 13.334,9.416C31.301,23.533 37.748,31.459 37.748,51.579C37.748,70.706 31.211,86.463 6.941,86.463C-16.362,86.463 -23.011,72.409 -23.011,54.302L-23.011,46.982L0,46.982Z",
    style: {
      fill: "rgb(5,38,58)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,98.2686,90.2014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-26.636L-16.166,-26.636L-16.166,5.852L-22.823,5.852L-22.823,-26.636L-38.985,-26.636L-38.985,-32.488L0,-32.488L0,-26.636Z",
    style: {
      fill: "rgb(60,115,142)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,149.069,96.0534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-38.34L0,0L-6.658,0L-6.658,-16.807L-31.948,-16.807L-31.948,0L-38.609,0L-38.609,-38.34L-31.948,-38.34L-31.948,-22.607L-6.658,-22.607L-6.658,-38.34L0,-38.34Z",
    style: {
      fill: "rgb(60,115,142)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,170.769,80.536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-7.305L26.152,-7.305L26.152,-1.722L0,-1.722L0,9.77L27.654,9.77L27.654,15.518L-6.657,15.518L-6.657,-22.823L26.957,-22.823L26.957,-17.078L0,-17.078L0,-7.305Z",
    style: {
      fill: "rgb(60,115,142)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,417.988,267.719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,38.343L-5.583,38.343L-5.583,32.543C-8.912,37.27 -14.175,39.309 -20.352,39.309C-33.077,39.309 -42.798,32.704 -42.798,19.173C-42.798,5.639 -33.346,-0.966 -20.78,-0.966C-7.57,-0.966 -1.342,5.103 -0.323,12.62L-7.895,12.62C-8.752,8.808 -11.92,4.781 -20.78,4.781C-29.104,4.781 -35.548,9.345 -35.548,19.173C-35.548,28.999 -29.104,33.565 -20.352,33.565C-12.457,33.565 -8.591,29.535 -7.733,23.36L-19.814,23.36L-19.814,17.936L0,17.936L0,38.343Z",
    style: {
      fill: "rgb(60,115,142)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,464.229,294.734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-15.684C0,-19.494 -1.986,-21.16 -6.336,-21.16L-24.81,-21.16L-24.81,-10.205L-6.336,-10.205C-1.986,-10.205 0,-11.871 0,-15.684M8.107,11.328L0.429,11.328L-9.076,-4.353L-24.81,-4.353L-24.81,11.328L-31.467,11.328L-31.467,-27.012L-5.855,-27.012C3.221,-27.012 7.354,-23.683 7.354,-15.684C7.354,-8.487 2.953,-5.855 -1.773,-4.997L-1.773,-4.782L8.107,11.328Z",
    style: {
      fill: "rgb(60,115,142)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,519.223,286.889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.003C0,-9.825 -6.447,-14.389 -14.82,-14.389C-23.199,-14.389 -29.644,-9.825 -29.644,0.003C-29.644,9.829 -23.199,14.395 -14.82,14.395C-6.447,14.395 0,9.829 0,0.003M7.25,0.003C7.25,13.534 -2.471,20.139 -14.82,20.139C-27.172,20.139 -36.89,13.534 -36.89,0.003C-36.89,-13.531 -27.172,-20.136 -14.82,-20.136C-2.471,-20.136 7.25,-13.531 7.25,0.003",
    style: {
      fill: "rgb(60,115,142)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,578.026,307.028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-39.306L0,-15.625C0,-4.726 -7.895,0 -19.223,0C-30.557,0 -38.448,-4.726 -38.448,-15.625L-38.448,-39.306L-31.791,-39.306L-31.791,-15.841C-31.791,-8.7 -26.633,-5.639 -19.223,-5.639C-11.813,-5.639 -6.661,-8.7 -6.661,-15.841L-6.661,-39.306L0,-39.306Z",
    style: {
      fill: "rgb(60,115,142)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,623.835,294.518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-15.252C0,-19.386 -2.146,-21.16 -6.82,-21.16L-24.112,-21.16L-24.112,-9.344L-6.82,-9.344C-2.146,-9.344 0,-11.118 0,-15.252M7.25,-15.36C7.25,-7.305 3.116,-3.868 -5.96,-3.868L-24.112,-3.868L-24.112,11.544L-30.77,11.544L-30.77,-26.796L-5.96,-26.796C3.116,-26.796 7.25,-23.415 7.25,-15.36",
    style: {
      fill: "rgb(60,115,142)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,377.942,83.6051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-33.736C46.998,-33.736 87.65,-15.419 107.26,11.225C94.977,-21.085 51.611,-44.961 0,-44.961C-51.612,-44.961 -94.977,-21.085 -107.261,11.225C-87.651,-15.419 -46.999,-33.736 0,-33.736",
    style: {
      fill: "rgb(253,71,18)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTfgMainlogo);
export default __webpack_public_path__ + "static/media/tfg_mainlogo.42e69a682f6631acd13baf14396ab52b.svg";
export { ForwardRef as ReactComponent };